var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật trang cá nhân",
        visible: _vm.dialogVisible,
        width: "800px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "10vh",
        "custom-class": "profile-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "userData",
          staticClass: "profile-form",
          attrs: {
            "label-width": "150px",
            model: _vm.userData,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "div",
            { staticClass: "profile-content" },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "align-items": "stretch" },
                  attrs: { gutter: 20, type: "flex" },
                },
                [
                  _c("el-col", { attrs: { span: 7 } }, [
                    _c("div", { staticClass: "avatar-panel h-100" }, [
                      _c("p", { staticClass: "section-title" }, [
                        _vm._v("Ảnh đại diện"),
                      ]),
                      _c("div", { staticClass: "avatar-card" }, [
                        _c(
                          "div",
                          { staticClass: "avatar-frame" },
                          [
                            _vm.avatarPreview
                              ? _c("el-image", {
                                  staticClass: "avatar-preview",
                                  attrs: {
                                    src: _vm.avatarPreview,
                                    fit: "cover",
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "avatar-placeholder" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                    }),
                                  ]
                                ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "avatar-meta" }, [
                          _c("p", { staticClass: "avatar-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.userData.fullName ||
                                  _vm.userData.username ||
                                  "Người dùng"
                              )
                            ),
                          ]),
                          _c("p", { staticClass: "avatar-hint" }, [
                            _vm._v("Hỗ trợ PNG, JPG, GIF • Tối đa 5MB"),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "avatar-actions" },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "upload",
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "show-file-list": false,
                                  "on-change": _vm.handleChangeUpload,
                                  "on-remove": _vm.handleRemove,
                                  "auto-upload": false,
                                  accept: "image/jpeg,image/png,image/gif",
                                  limit: "1",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "upload-trigger",
                                    attrs: { type: "primary", plain: "" },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.avatarPreview
                                            ? "Đổi ảnh đại diện"
                                            : "Thêm ảnh đại diện"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.previewImage !== ""
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "remove-trigger",
                                    on: { click: _vm.handleRemove },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _c("span", [_vm._v("Hủy ảnh mới")]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 17 } }, [
                    _c(
                      "div",
                      { staticClass: "form-panel h-100" },
                      [
                        _c("p", { staticClass: "section-title" }, [
                          _vm._v("Thông tin cá nhân"),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Tài khoản", prop: "username" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.userData.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userData, "username", $$v)
                                },
                                expression: "userData.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Nickname/Họ tên",
                              prop: "fullName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập Nickname/Họ tên" },
                              model: {
                                value: _vm.userData.fullName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userData, "fullName", $$v)
                                },
                                expression: "userData.fullName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Số điện thoại", prop: "phone" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "Số điện thoại nhận SMS",
                                  placement: "top",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "number",
                                    placeholder: "Nhập số điện thoại",
                                  },
                                  model: {
                                    value: _vm.userData.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userData, "phone", $$v)
                                    },
                                    expression: "userData.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Giới tính", prop: "gender" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "gender-group",
                                model: {
                                  value: _vm.userData.gender,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userData, "gender", $$v)
                                  },
                                  expression: "userData.gender",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "Nam" } }, [
                                  _vm._v("Nam"),
                                ]),
                                _c("el-radio", { attrs: { label: "Nữ" } }, [
                                  _vm._v("Nữ"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.userData.appType === "parent"
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "Ngày sinh" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    format: "dd-MM-yyyy",
                                    type: "date",
                                    "picker-options": _vm.pickerOptions,
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "Chọn ngày sinh",
                                  },
                                  model: {
                                    value: _vm.userData.birthday,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userData, "birthday", $$v)
                                    },
                                    expression: "userData.birthday",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "el-form-item",
                              {
                                attrs: { label: "Ngày sinh", prop: "birthday" },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    format: "dd-MM-yyyy",
                                    type: "date",
                                    "picker-options": _vm.pickerOptions,
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "Chọn ngày sinh",
                                  },
                                  model: {
                                    value: _vm.userData.birthday,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userData, "birthday", $$v)
                                    },
                                    expression: "userData.birthday",
                                  },
                                }),
                              ],
                              1
                            ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Email", prop: "email" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập email" },
                              model: {
                                value: _vm.userData.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userData, "email", $$v)
                                },
                                expression: "userData.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer profile-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("userData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-save",
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("userData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }